// extracted by mini-css-extract-plugin
export var numpadContainer = "_s4-1";
export var phoneButton = "_s4-0";